import { useDirectusFiles, useHead } from "#imports";
import { useNuxtApp, useRoute } from "#app";
import { useGenerateMeta } from "./useGenerateMeta.mjs";
import { useParseTemplate } from "./useParseTemplate.mjs";
import get from "lodash-es/get";
import set from "lodash-es/set";
import clone from "lodash-es/clone";
import { FIELDS } from "../constants.mjs";
import { setDefaultMetaRobots } from "../utils/index.mjs";
export const useDirectusCollectionSeo = (collectionName, model = {}) => {
  const { $SEOAdvanceConfig } = useNuxtApp();
  const { getThumbnail } = useDirectusFiles();
  const route = useRoute();
  const lang = route?.params?.lang ?? "vi";
  let collectionSetting = {};
  collectionSetting = get($SEOAdvanceConfig, `${collectionName}.${lang}`, {});
  console.log("$SEOAdvanceConfig", $SEOAdvanceConfig, collectionSetting);
  collectionSetting = clone(collectionSetting);
  Object.keys(collectionSetting)?.map((item) => {
    if (collectionSetting[item]) {
      console.log("collectionSetting?.[item]", item, collectionSetting?.[item]);
      if ("string" !== typeof collectionSetting?.[item]) {
        return;
      }
      set(collectionSetting, item, useParseTemplate(collectionSetting?.[item], model));
    }
  });
  console.log("collectionSetting.meta-tit", collectionSetting);
  console.log("model.meta-tit", model?.translations?.title);
  const seoModel = get(model, FIELDS.seo_detail, {});
  const description = seoModel?.meta_description || collectionSetting?.meta_description;
  const meta_keywords = seoModel?.meta_keywords || collectionSetting?.meta_keywords;
  const meta_title = seoModel?.meta_title || collectionSetting?.meta_title;
  if (import.meta.env.DEV) {
  }
  const basicMeta = [];
  const metas = { description, meta_keywords };
  Object.keys(metas).map((meta) => {
    const metaValue = get(metas, meta, null);
    if (metaValue) {
      basicMeta.push(
        useGenerateMeta(meta, metaValue)
      );
    }
  });
  let meta_robots = seoModel?.meta_robots || collectionSetting?.meta_robots;
  if (meta_robots) {
    console.log("meta_robots", meta_robots);
    meta_robots = setDefaultMetaRobots(meta_robots);
    if (meta_robots.length > 0) {
      basicMeta.push(useGenerateMeta("robots", meta_robots.join(", ")));
    }
  }
  useHead({
    meta: basicMeta
  });
  if (meta_title) {
    useHead({
      title: meta_title
    });
  }
  let metaSocial = seoModel?.meta_social || collectionSetting?.meta_social;
  if (typeof metaSocial != "object") {
    try {
      metaSocial = JSON.parse(metaSocial);
    } catch (e) {
      metaSocial = {};
    }
  }
  const metaTw = [
    useGenerateMeta("twitter:card", "summary")
  ];
  const imgTw = get(model, "seo_detail.twitter_image") || get(model, "thumbnail.id") || get(model, "translations.thumbnail.id") || get(model, "thumbnail") || get(model, "translations.thumbnail") || get(collectionSetting, "twitter_image");
  if (imgTw)
    metaTw.push(useGenerateMeta("twitter:image", getThumbnail(imgTw)));
  if (metaSocial?.twitter_title || meta_title) {
    metaTw.push(useGenerateMeta("twitter:title", useParseTemplate(metaSocial?.twitter_title || meta_title, model)));
  }
  if (metaSocial?.twitter_description || description) {
    metaTw.push(useGenerateMeta("twitter:description", useParseTemplate(metaSocial?.twitter_description || description, model)));
  }
  const metaFace = [{
    hid: "og:type",
    name: "og:type",
    content: "website"
  }];
  const imageShare = get(model, "seo_detail.facebook_image") || get(model, "thumbnail.id") || get(model, "translations.thumbnail.id") || get(model, "thumbnail") || get(model, "translations.thumbnail") || get(collectionSetting, "facebook_image");
  if (imageShare)
    metaFace.push(useGenerateMeta("og:image", getThumbnail(imageShare)));
  if (metaSocial?.facebook_title || meta_title) {
    metaFace.push(useGenerateMeta("og:title", useParseTemplate(metaSocial?.facebook_title || meta_title, model)));
  }
  if (metaSocial?.facebook_description || description) {
    metaFace.push(useGenerateMeta("og:description", useParseTemplate(metaSocial?.facebook_description || description, model)));
  }
  useHead({
    meta: [
      ...metaTw,
      ...metaFace
    ]
  });
};
